// Standard library imports
import React, { useState } from 'react';
// External library imports
import { Form, Formik } from 'formik';
import { toast } from 'react-toastify';
import _ from 'lodash';
// Internal module imports
import classes from '../../../../../styles/AllDevices.module.css';
import Typography from '../../../../../components/Typography/Typography';
import { useLoader } from '../../../../../hooks';
import NewJSONEditor from '../../../../../components/JSONEditor/NewJSONEditor';
import { RootMFRRService } from '../../../../../services/RootMFRRService';
import { CamelCaseToTextCase } from '../../../../../utils/stringHelper';

const UpdateRedisValue = ({ data, setOpen, fetchValues, action = '' }) => {
    const [startLoader, stopLoader] = useLoader();

    const [initialValues, setInitialValue] = useState({
        redisData: {
            timestamp: action === 'view' ? _.get(data, ['redisData', 'timestamp'], '') : 'To be determined',
            value: _.get(data, ['redisData', 'value'], ''),
        },
    });

    const handleSubmit = (val) => {
        const payload = {
            ...val.redisData,
            key: data.key,
            eicCode: data.eicCode,
        };
        RootMFRRService.UpdateRedisValue(payload, startLoader, handleSuccess, handleError, stopLoader);
    };

    const handleSuccess = () => {
        toast.success('Value updated.');
        fetchValues();
        setOpen({
            status: false,
            data: {},
        });
    };

    const handleError = (err) => {
        console.log(err);
        if (err && err.response) toast.error(err.response.data.message);
    };

    return (
        <div style={{ width: '80vw' }}>
            <div>
                <Typography content={`${CamelCaseToTextCase(action)} Redis Value`} />
            </div>
            <div className={classes.FormContent}>
                <Formik initialValues={initialValues} enableReinitialize onSubmit={handleSubmit}>
                    {({ errors, touched, values, isValidating, ...props }) => {
                        return (
                            <Form>
                                <div style={{ marginTop: '2vh' }}>
                                    <NewJSONEditor name="redisData" defaultValue={initialValues?.redisData} height="75vh" />
                                </div>
                                <div>
                                    <div className={classes.ButtonContainer}>
                                        <div>
                                            <button
                                                className="btn-secondary"
                                                onClick={() => {
                                                    setOpen({ status: false, data: {} });
                                                }}
                                                type="button"
                                            >
                                                Cancel
                                            </button>
                                        </div>
                                        {
                                            action === 'update' && <div>
                                                <button type="submit" className="btn-primary">
                                                    Submit
                                                </button>
                                            </div>
                                        }
                                    </div>
                                </div>
                            </Form>
                        );
                    }}
                </Formik>
            </div>
        </div>
    );
};

export default UpdateRedisValue;
